import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import * as Sentry from "@sentry/react";
import { scrubToastTelemetry, toastReplayIntegrations } from "./utilities/toastTelemetryPrivacy";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";

//import "@fortawesome/fontawesome-free/css/all.min.css";
//import "bootstrap-css-only/css/bootstrap.min.css";
//import "mdbreact/dist/css/mdb.css";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import RightworkThemeProvider from "./theme/RightworkThemeProvider";

import reducer from "./store/reducers/auth";


const REACT_APP_ENABLE_SENTRY_REPLAY = process.env.REACT_APP_ENABLE_SENTRY_REPLAY === "TRUE";

Sentry.init({
  dsn: "https://2f1ec5902c6aee580268ed76d6e5998b@o4505479206207488.ingest.us.sentry.io/4506068720680960",
  integrations: toastReplayIntegrations(Sentry, window.location.pathname),
  beforeSend: scrubToastTelemetry,
  beforeSendTransaction: scrubToastTelemetry,
  beforeBreadcrumb: scrubToastTelemetry,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: (REACT_APP_ENABLE_SENTRY_REPLAY ? 1.0 : 0.0),
});


const composeEnhances = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducer, composeEnhances(applyMiddleware(thunk)));

const app = (
  <RightworkThemeProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </RightworkThemeProvider>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
